document.addEventListener('click', function (event) {
  var toggleBtn = event.target.closest('[data-size-chart-toggle]');

  if (toggleBtn) {
    var chart = toggleBtn.closest('[data-size-chart]');
    var content = chart && chart.querySelector('[data-size-chart-content]');

    if (content) {
      var isHidden = content.hasAttribute('hidden');

      if (isHidden) {
        content.removeAttribute('hidden');
      } else {
        content.setAttribute('hidden', '');
      }

      var icon = toggleBtn.querySelector('.impuria-fit-size-chart__toggle-icon');
      if (icon) {
        icon.textContent = isHidden ? '−' : '+';
      }

      toggleBtn.classList.toggle('is-open', isHidden);
    }

    return;
  }

  var unitBtn = event.target.closest('[data-size-units-toggle]');

  if (unitBtn) {
    var units = unitBtn.getAttribute('data-units');
    var group = unitBtn.closest('.impuria-fit-size-chart__units');

    if (group) {
      group.querySelectorAll('[data-size-units-toggle]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn === unitBtn);
      });
    }

    var chartRoot = unitBtn.closest('[data-size-chart]');

    if (chartRoot) {
      chartRoot.querySelectorAll('[data-units-cell]').forEach(function (cell) {
        var value = units === 'in' ? cell.getAttribute('data-in') : cell.getAttribute('data-mm');
        if (value !== null) {
          cell.innerHTML = value;
        }
      });
    }
  }
});
